import {
    AutoplayToggleButtonWithTitle
} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/AutoplayToggleButtonWithTitle';
import React from 'react';

type ToggleTurboModeButtonProps = {
    hidden: boolean;
    onToggle: (value: boolean) => void;
    value: boolean | null;
    width: number;
};

export function ToggleTurboModeButton(props: ToggleTurboModeButtonProps): JSX.Element | null {
    const {hidden, onToggle, value, width} = props;

    if (hidden) {
        return null;
    }

    return <AutoplayToggleButtonWithTitle onToggle={onToggle} textID={'turboMode'} value={value} width={width}/>;
}
